import React from 'react';
import { formatDate } from '../../../../helper/formatDate';

export const MeetingDetailsCell = ({ row }) => {
    const hasMeetingDate = Boolean(row.meetingDate);

    return (
        <div className="py-1" style={{ maxWidth: '360px' }}>
            {/* Scheduled Meeting Date Banner */}
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-1.5 mb-1.5">
                {hasMeetingDate ? (
                    <span className="badge bg-soft-info text-info border border-info-subtle px-2 py-1 fs-12 fw-semibold d-inline-flex align-items-center gap-1">
                        <i className="ri-calendar-check-fill text-info" />
                        <span>Meeting Date:</span>
                        <strong>{formatDate(row.meetingDate)}</strong>
                    </span>
                ) : (
                    <span className="text-muted fst-italic fs-11">No meeting date specified</span>
                )}

                <span className="badge bg-soft-primary text-primary px-2 py-0.5 fs-11 fw-semibold text-uppercase">
                    Meeting Arrange
                </span>
            </div>

            {/* Conversation Notes / Meeting Agenda */}
            <div
                className="p-2 bg-light-subtle rounded border border-light-subtle fs-12 text-body lh-sm"
                style={{ whiteSpace: 'pre-wrap', maxHeight: '75px', overflowY: 'auto' }}
            >
                {row.remark ? (
                    <span>{row.remark}</span>
                ) : (
                    <span className="text-muted fst-italic">No conversation notes recorded.</span>
                )}
            </div>
        </div>
    );
};

export default MeetingDetailsCell;
